import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { BaseResponse } from '../models/base.response';
import { Visionboard, VisionboardDto } from '../models/visionboard.interface';

@Injectable({
  providedIn: 'root'
})
export class VisionboardService {
  constructor(private http: HttpClient) {}
  
  getUserVisionboards(userId: string): Observable<BaseResponse<Visionboard[]>> {
    return this.http.get<BaseResponse<Visionboard[]>>(`${environment.apiUrl}/users/${userId}/visionboards`);
  }
  
  saveVisionboard(userId: string, visionboard: VisionboardDto): Observable<BaseResponse<Visionboard>> {
    return this.http.post<BaseResponse<Visionboard>>(`${environment.apiUrl}/users/${userId}/visionboards`, visionboard);
  }
  
  deleteVisionboard(userId: string, visionboardId: string): Observable<BaseResponse<any>> {
    return this.http.delete<BaseResponse<any>>(`${environment.apiUrl}/users/${userId}/visionboards/${visionboardId}`);
  }
  
  // Utilitario para convertir archivo a base64
  fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = error => reject(error);
    });
  }
} 